const {KitModule, registerModule} = window;

class RotatingTitle extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.$wordsWrapper.style.setProperty('--width', `${this.$current.offsetWidth}px`);
    this.$wordsWrapper.style.setProperty('--width-mobile', `${this.maxWordsWidth}px`);

    $element.dataset.ready = true;

    setTimeout(() => {
      this.rotateText();
      setInterval(() => this.rotateText(), 2300);
    }, 1000);
  }

  rotateText() {
    this.$current = this.$wordsWrapper.querySelector('.current');
    this.$next = this.$wordsWrapper.querySelector('.next');
    const nextNextWord = this.$next.nextElementSibling ?
      this.$next.nextElementSibling :
      this.$wordsWrapper.firstElementChild;
    this.$current.classList.remove(this.CURRENT_CLASS);
    this.$next.classList.remove(this.NEXT_CLASS);
    this.$next.classList.add(this.CURRENT_CLASS);
    nextNextWord.classList.add(this.NEXT_CLASS);
    this.$wordsWrapper.style.setProperty('--width', `${this.$next.offsetWidth}px`);
  }

  setVars() {
    this.$current = this.$wordsWrapper.querySelector('.current');
    this.$next = this.$wordsWrapper.querySelector('.next');
    this.wordsWidths = this.$word.map(($word) => $word.offsetWidth);
    this.maxWordsWidth = Math.max(...this.wordsWidths);
    this.CURRENT_CLASS = 'current';
    this.NEXT_CLASS = 'next';
  }
}

registerModule('RotatingTitle', RotatingTitle);
